export default function joinClasses(baseClass, modifiers, additionalClasses = '') {
  let modifierClasses = modifiers.filter(x => x).map(modifier => `${baseClass}--${modifier}`).join(' ');
  return `${baseClass} ${modifierClasses} ${additionalClasses}`;
}
